import { CalendarComponent } from '@syncfusion/ej2-react-calendars';
import DatePicker from 'react-date-picker'
import Calendar from "react-calendar"
import React from 'react'
import { BrowserRouter, Switch, Route, NavLink, Link, Navbar, Routes, useNavigate, useLocation } from 'react-router-dom';

const OfferRouteCalendarStart = () => {
    const [date, setDate] = React.useState(new Date());
    const [time, setTime] = React.useState(null);
    const [detail, setDetail] = React.useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const locale = 'fr-CA';
    
    const {routeId} = location.state;
    const {start} = location.state;
    const {end} = location.state;
    const {details} = location.state;

    const onDateChange = (date) => {
        setDate(date);
    }

    const onTimeChange = () => {
        setTime(document.getElementById("time").value);
        
        sessionStorage.setItem("OfferRouteCalendarStartTime",document.getElementById("time").value);
      
    }

    const confirmDate = () => {
        sessionStorage.setItem("OfferRouteCalendarStartDate",new Intl.DateTimeFormat(
            locale, 
            {
              year: "numeric", 
              month: "2-digit", 
              day: "2-digit"
            }).format(date));
        
        navigate("/OfferRouteCalendarEnd", {state:{
            routeId:routeId,
            start:start,
            end:end,
            details:details
        }});
    }
    /*return(
        <CalendarComponent style={{width:"100%", display:"contents"}}/>
    );*/
    return(
        <div className='myCalendar'>
            <NavLink className='back' to="/MyRoutes"></NavLink>
            <h2>Πότε αναχωρείς;</h2>
            <p>Επέλεξε ημερομηνία</p>
            <Calendar onChange={onDateChange} value={date} />
            <div className='timePicker'>
                <p>Επέλεξε ώρα</p>
                <input id="time" type="time" onChange={() => onTimeChange()}></input>
            </div>
            <div className='confirmDate'>
                <button onClick={() => confirmDate()}>Ορισμός ημερομηνίας</button>
            </div>
        </div>  
    );
}

export default OfferRouteCalendarStart;